import { userConstants } from '../constants';

let user = JSON.parse(localStorage.getItem('user'));
const initialState = user ? { loggedIn: true, user, loading: false } : {};

export function authentication(state = initialState, action) {
  switch (action.type) {
    case userConstants.LOGIN_REQUEST:
      return {
        loggingIn: true,
        user: action.user
      };
    case userConstants.LOGIN_SUCCESS:
      return {
        loggedIn: true,
        user: action.user
      };
    case userConstants.LOGIN_FAILURE:
      return {};
    case userConstants.LOGOUT:
      return {};
    case userConstants.FORGOT_REQUEST:
      return {
        loading: true
      };
    case userConstants.FORGOT_SUCCESS:
      return {
        loading: false,
        user: action.username
      };
    case userConstants.FORGOT_FAILURE:
      return {};
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/authentication.reducer.js